export var atomicMapTooltip = {
    tooltip: ['leading-normal', 'text-sm', 'absolute', 'left-0', 'top-0', 'z-50', 'max-w-px-240'],
    title: [
        'px-px-8',
        'py-px-8',
        'shadow-md',
        'text-white',
        'rounded-sm',
        'min-w-px-32',
        'min-h-px-32',
        'max-h-px-256',
        'flex',
        'items-center',
        'justify-center',
    ],
    arrow: ['absolute', 'w-px-12', 'h-px-12', 'overflow-hidden', 'bg-center'],
    arrowContent: [
        'absolute',
        'left-0',
        'top-0',
        'right-0',
        'bottom-0',
        'block',
        'w-px-6',
        'h-px-6',
        'shadow-md',
    ],
    childrenContainer: ['box-border', 'inline-block'],
};
export var atomicMapTitPos = {
    Bottom: ['pt-px-10'],
    BottomLeft: ['pt-px-10'],
    BottomRight: ['pt-px-10'],
    Left: ['pr-px-10'],
    LeftTop: ['pr-px-10'],
    LeftBottom: ['pr-px-10'],
    Right: ['pl-px-10'],
    RightTop: ['pl-px-10'],
    RightBottom: ['pl-px-10'],
    Top: ['pb-px-10'],
    TopLeft: ['pb-px-10'],
    TopRight: ['pb-px-10'],
};
export var ArrowPosStyleMap = {
    Bottom: {
        top: '-2px',
        left: '50%',
        transform: 'translateX(-50%)',
    },
    BottomLeft: {
        top: '-2px',
        left: '16px',
    },
    BottomRight: {
        top: '-2px',
        right: ' 16px',
    },
    Top: {
        left: '50%',
        transform: 'translateX(-50%)',
        bottom: '-2px',
    },
    TopLeft: {
        left: '16px',
        bottom: '-2px',
    },
    TopRight: {
        right: '16px',
        bottom: '-2px',
    },
    Left: {
        top: '50%',
        transform: 'translateY(-50%)',
        right: '-2px',
    },
    LeftTop: {
        top: '5px',
        right: '-2px',
    },
    LeftBottom: {
        right: '-2px',
        bottom: '5px',
    },
    Right: {
        left: '-2px',
        top: '50%',
        transform: ' translateY(-50%)',
    },
    RightTop: {
        left: '-2px',
        top: '5px',
    },
    RightBottom: {
        left: '-2px',
        bottom: '5px',
    },
};
